module.exports = __webpack_public_path__ + "static/history1-8d75370792d3dd0a0ff20d8551703d63.pdf";